import {
  ExtraAttributesCarrierType,
  ExtraAttributesOptionType,
  ExtraAttributesPlanType,
  ExtraAttributesSimType,
  MobilityProduct,
  VariantsChildrenType,
  VariantsType,
} from 'screens/AccessExpressV3/accessExpress.types';
import { SelectedIndices } from 'screens/AccessExpressV3/BaseComponents/ProductSummary';

export type YesNoNullable = 'yes' | 'no' | null;

export type DataPlanNeededType = {
  neededPlan: YesNoNullable;
  activation: 'hot' | 'cold' | null;
};
export type GlobalType = {
  scope: 'global' | 'domestic' | null;
  globalZone: keyof typeof GlobalZoneEnum | null;
  coverage: YesNoNullable;
  orderCarrier: ('AT&T' | 'T-Mobile' | 'Verizon')[];
};

export type SelectedAttributes = {
  chooseVariant: VariantsType | null;
  choosePricingOption: VariantsChildrenType | null;
  carrier: ExtraAttributesCarrierType | null;
  simType: ExtraAttributesSimType | null;
  dataPlanNeeded: DataPlanNeededType;
  simOption: ExtraAttributesOptionType | null;
  planType: ExtraAttributesPlanType | null;
  planTypeOption: ExtraAttributesOptionType | null;
  global: GlobalType;
  secondaryPlan: YesNoNullable;
};

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object
    ? T[P] extends Array<infer U>
      ? Array<DeepPartial<U>>
      : DeepPartial<T[P]>
    : T[P];
};

export type DotNotation<T, Prefix extends string = ''> = {
  [K in keyof T]: T[K] extends object
    ? T[K] extends Array<unknown> | null
      ? `${Prefix}${Extract<K, string>}`
      :
          | DotNotation<T[K], `${Prefix}${Extract<K, string>}.`>
          | `${Prefix}${Extract<K, string>}`
    : `${Prefix}${Extract<K, string>}`;
}[keyof T];

export type OneLevelNestedKeys<T> = {
  [K in keyof T]: NonNullable<T[K]> extends object
    ? keyof NonNullable<T[K]>
    : never;
}[keyof T];

export enum GlobalZoneEnum {
  'eu-zone' = 'Zone EU',
  'zone-1' = 'Zone 1',
  'zone-2' = 'Zone 2',
  'zone-3' = 'Zone 3',
  'zone-4' = 'Zone 4',
}

export interface MobilityAttributesProps
  extends Pick<MobilityProduct, 'variants' | 'productDesc'> {
  onAddToCart: (
    selected: SelectedAttributes,
    additionalSelected: SelectedAttributes,
    update: boolean,
  ) => void;
  setSelectedIndices: React.Dispatch<React.SetStateAction<SelectedIndices>>;
}
